import React from "react";
import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ size = 16, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold bg-[#c39d2b]/15 text-[#8a6a10] border border-[#c39d2b]/40 ${className}`}
      title="Identity verified"
      data-testid="verified-badge"
    >
      <BadgeCheck style={{ width: size, height: size }} className="text-[#c39d2b]" />
      Verified
    </span>
  );
}
